module.exports = __webpack_public_path__ + "static/media/image-4.8f6ed59a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-4.jpg
// module id = 281
// module chunks = 0